import React, { useContext } from 'react';
import S from "./LargestBranches";
import CardHeader from "../CardHeader";
import FundContext from '@/components/FundSingle/FundProvider';
import Table from "../../../Table/index";
import moment from 'moment';

const LargestBranches: React.FC<FundSingle> = ({short = false}) => {
    const { fundRiskDetails, getIndustryBySectorCode, getIndustryIconBySectorCode, outputPercentage } = useContext(FundContext);

    const portfolio = fundRiskDetails?.Portfolios?.[0];
    const stockSectorBreakdown = portfolio?.GlobalStockSectorBreakdown
        ?.find((item: any) => item?.SalePosition === 'N')
        ?.BreakdownValues;

    if (!portfolio || !Array.isArray(stockSectorBreakdown)) return null;

    const date = moment(portfolio.Date).format('YYYY-MM-DD');

    var tableRows: [string, React.ReactNode[]][] = [];

    stockSectorBreakdown.sort((a: any, b: any) => b.Value - a.Value);

    stockSectorBreakdown.forEach((item: any) => {
        var industryName = getIndustryBySectorCode(item.Type);
        var IndustryIcon = getIndustryIconBySectorCode(item.Type);

        tableRows.push([
            industryName,
            [
                <>
                    {IndustryIcon && <div className={"sector-branch-icon sector-branch-icon-" + item.Type}><IndustryIcon /></div>}
                    <span className={'sector-id-' + item.Type}>{industryName}</span>
                </>,
                <span>{outputPercentage(item.Value)}</span>
            ]
        ]);
    });

    var tableData = {
        headings: ['AKTIESEKTORER', '%'],
        rows: tableRows // This is now an array
    };

    return (
        <S.AllocationWrapper>
            <CardHeader title="Största branscher (aktier)" subTitle={date} />
            <Table tableData={tableData} skipKey={true} />
        </S.AllocationWrapper>
    );
};

export default LargestBranches;
